/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index checkbox to autogenerate all the components and extensions
 * Used by "prepareCheckboxs"
 */

import Checkbox from './checkbox/Checkbox'
export * from './checkbox/Checkbox'
export default Checkbox
